<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('project.update_title') }}</span>
            <span v-else>{{ $t('project.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('project.name') }}</label>
          <b-form-input type="text" :placeholder="$t('project.name_placeholder')"
            :class="{ 'is-invalid': fErr('name') }"
            v-model="entity.name"/>
        </b-form-group>
        <b-form-checkbox v-model="entity.hide_other_tags">
          {{ $dt('project.white_listed_tag_checkbox', 'Show only project tags') }}
        </b-form-checkbox>
        <b-form-checkbox v-model="entity.object_text_labeling">
          {{ $dt('project.object_text_labeling', 'Object text labeling') }}
        </b-form-checkbox>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'Projects' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
    <ProjectTags ref="tagList" v-if="isUpdateForm" :project_id="id"/>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import { mapGetters, mapActions } from 'vuex';
import Services from '@/services/index';
import VT from '@/store/types';
import ProjectTags from '@/views/ProjectTags/ProjectTags';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          name: '',
          hide_other_tags: false,
          object_text_labeling: false,
        };
      },
    },
  },
  components: {
    ProjectTags
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
  },
  methods: {
    ...mapActions('Auth', [VT.LOAD_USER_INFO]),
    getForUpdate: Services.projects.editData,
    getForCreate: Services.projects.createData,
    pushUpdate: Services.projects.update,
    pushCreate: Services.projects.create,
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.project : { ...this.entity, ...data.data.project };
        this.$refs.tagList.getData();
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.entity).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          // After successful create
          // if (this.$can('edit', 'projects')) {
          this.$router.push({ name: 'ProjectUpdate', params: { id: data.data.id } });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
        this[VT.LOAD_USER_INFO]().then(() => { });
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style scoped></style>
